export const getCurrentPagePosts = (state) => state.forum.currentPagePosts;
export const getCurrentPageTopic = (state) => state.forum.currentPageTopic;
